var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource_down"},[_c('div',{staticClass:"down_info"},[_c('i',{staticClass:"iconfont cloud-xiazai3  i_down"}),_c('font',[_vm._v(_vm._s(_vm.fileName))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }